export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'
export const HTTP_HEADER_MALL_ID_KEY = 'X-Mall-Id'

export const STYLE_FILL_COLOR = 'fillColor'